module.exports = new __parcel__URL__("icons.7d2de116.svg").toString();